export interface VersionInfo {
  gitCommitHash: string;
  gitCommitDate: string;
  buildDate: string;
}

// This will be generated at build time
export const VERSION_INFO: VersionInfo = {
  gitCommitHash: import.meta.env.VITE_GIT_COMMIT_HASH || "unknown",
  gitCommitDate: import.meta.env.VITE_GIT_COMMIT_DATE || "unknown",
  buildDate: import.meta.env.VITE_BUILD_DATE || new Date().toISOString(),
};
